<template>
  <estimate-tracker :estimate='estimate'></estimate-tracker>
</template>

<script>
import EstimateTracker from '@/components/trackers/EstimateTracker';

export default {
  name: 'snow-action-tracker',
  props: {
    estimate: {
      required: true
    }
  },
  components: {
    'estimate-tracker': EstimateTracker
  }
}
</script>
